import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';


class Tab extends Component {

  leftRouters = () => {
    if (!this.props.leftRouters || this.props.leftRouters.length < 0) return null;
    let items = this.props.leftRouters.map((item, i) => {
      return <NavLink className="tab-nav" activeClassName="active" to={item.route} key={i}>{item.title}</NavLink>
    });
    return <div className="left-tabs">{items}</div>
  }

  rightRouters = () => {
    if (!this.props.rightRouters || this.props.rightRouters.length < 0) return null;
    let items = this.props.rightRouters.map((item, i) => {
      return <NavLink className="tab-nav" activeClassName="active" to={item.route} key={i}>{item.title}</NavLink>
    });
    return <div className="right-tabs">{items}</div>
  }

  render() {
    return (
      <div className="tab-navs dark">
        <div className="list-nav row">
          <div className="container">
            <div className="row" style={{ display: "block" }}>
              {this.leftRouters()}
              {this.rightRouters()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tab;